import axios from '@/core/http'
import { VueConstructor } from 'vue/types/umd'

const AxiosPlugin = {
  install(Vue: VueConstructor) {
    ;(Vue as any).$axios = axios
    Vue.prototype.$axios = axios
  },
}

export { AxiosPlugin }
